<div class="title">
  <h2 class="vox-heading-2" translate>equipment.title</h2>
</div>

<ul ngbNav [activeId]="activeId" class="nav-tabs tab">
  <li ngbNavItem="telephony">
    <a ngbNavLink routerLink="./telephony" class="tab-link">
      <div class="tab-title-container">
        <i class="icon-small-fax"></i>
        <span class="tab-title-text" translate>equipment.tabs.telephony</span>
      </div>
    </a>
  </li>
  <li ngbNavItem="connectivity">
    <a ngbNavLink routerLink="./connectivity" class="tab-link">
      <div class="tab-title-container">
        <i class="fas fa-wifi"></i>
        <span class="tab-title-text" translate>equipment.tabs.connectivity</span>
      </div>
    </a>
  </li>
</ul>

<router-outlet></router-outlet>